/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coveradjustapply2Inputs */

const en_coveradjustapply2 = /** @type {(inputs: Coveradjustapply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_coveradjustapply2 = /** @type {(inputs: Coveradjustapply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übernehmen`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Coveradjustapply2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coveradjustapply2 = /** @type {((inputs?: Coveradjustapply2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coveradjustapply2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coveradjustapply2(inputs)
	return de_coveradjustapply2(inputs)
});
export { coveradjustapply2 as "coverAdjustApply" }